import { ConfigurationSecurityRight } from './modules/configuration.security.module';
import { IndividualComplianceSecurityRight } from './modules/individual.compliance.security.module';
import { WorkComplianceSecurityRight } from './modules/work.compliance.security.module';
import { QuoteSecurityRight } from './modules/quote.security.module';
import { FinanceSecurityRight } from './modules/finance.security.module';
import { JobSecurityRight } from './modules/job.security.module';
import { ClaimSecurityRight } from './modules/claim.security.module';
import { DefectSecurityRight } from './modules/defect.security.module';
import { AssetSecurityRight } from './modules/asset.security.module';
import { SchedulerSecurityRight } from './modules/scheduler.security.module';
import { AppSecurityRight } from './modules/app.security';
import { CrmSecurityRight } from './modules/crm.security.module';
import { VariationSecurityRight } from './modules/variation.security.module';
import { RecurringJobSecurityRight } from './modules/recurring.job.security.module';
import { TaskSecurityRight } from './modules/task.security.module';
import { TimesheetSecurityRight } from './modules/timesheet.security.module';
import { PortalClientSecurityRight } from './modules/portal.clients.security.module';
import { FormSecurityRight } from './modules/form.security.module';
import { PortalContractorSecurityRight } from './modules/portal.contractors.security.module';
import { EquipmentSecurityRight } from './modules/equipment.security.module';
import { InboundEmailSecurityRight } from './modules/inbound.email.security.module';

export const managePricingRights = [ConfigurationSecurityRight.ManagePricing];
export const configViewAuditLog = [ConfigurationSecurityRight.ViewAuditLog];
export const manageMetaDataRights = [ConfigurationSecurityRight.ManageMetadata];
export const manageTemplateRights = [ConfigurationSecurityRight.ManageTemplates];
export const manageTenancyRights = [ConfigurationSecurityRight.ManageTenancy];


export const manageIndividualComplianceRulesRights = [IndividualComplianceSecurityRight.ManageComplianceRules];
export const manageIndividualComplianceRights = [IndividualComplianceSecurityRight.ManageCompliance];

export const manageWorkComplianceRulesRights = [WorkComplianceSecurityRight.ManageComplianceRules];

export const quoteManageRights = [QuoteSecurityRight.Manage];
// export const quoteMarkRights = [QuoteSecurityRight.Mark];

export const financeInvoiceRights = [FinanceSecurityRight.ManageInvoices];
export const financeBillRights = [FinanceSecurityRight.ManageBills];

export const jobManageRights = [JobSecurityRight.Manage];
export const dispatchRights = [JobSecurityRight.Dispatch];
export const finaliseJobRights = [JobSecurityRight.FinaliseJob];
export const finalliseWorkOrderRights = [JobSecurityRight.FinalliseWorkOrder];
export const completionDateRights = [JobSecurityRight.CompletionDate];
export const finaliseDateRights = [JobSecurityRight.FinaliseDate];
export const processJobRights = [JobSecurityRight.ProcessJob];
export const processWorkOrderRights = [JobSecurityRight.ProcessWorkOrder];
export const completeStagesWithUnresolvedTasksRights = [JobSecurityRight.CompleteStagesWithUnresolvedTasks];
export const approveClaimsWithUnresolvedTasksRights = [ClaimSecurityRight.ApproveClaimsWithUnresolvedTasks];
export const rejectClaimsRights = [ClaimSecurityRight.RejectClaims];
export const overrideCompletionGatesRights = [TaskSecurityRight.OverrideCompletionGates];
export const jobViewPricingRights = [JobSecurityRight.ViewPricing];
export const jobModifyPricingRights = [JobSecurityRight.ModifyPricing];
export const jobModifyAfterFinaliseRights = [JobSecurityRight.ModifyJobAfterFinalise];
export const jobModifyLockedItemRights = [JobSecurityRight.ModifyLockedItems];
export const modifyCompletionDate = [JobSecurityRight.CompletionDate];
export const modifyFinaliseDate = [JobSecurityRight.FinaliseDate];
export const jobManageActivityRights = [JobSecurityRight.ManageActivity];
export const jobManageOtherUserActivityRights = [JobSecurityRight.ManageOtherUserActivity];
export const jobManageComplianceRights = [WorkComplianceSecurityRight.ManageCompliance];
export const jobManagePurchaseOrderRights = [JobSecurityRight.ManagePurchaseOrder];
export const jobManageInvoicesRights = [JobSecurityRight.ManageInvoices];
export const jobManageBillsRights = [JobSecurityRight.ManageBills];
export const jobAccessQuotes = [JobSecurityRight.AccessQuote];
export const jobAccessSalesOrder = [JobSecurityRight.ManageSalesOrder];
export const jobViewAuditLog = [JobSecurityRight.ViewAuditLog];

export const accessDefect = [DefectSecurityRight.CanAccess];
export const manageDefect = [DefectSecurityRight.Manage];


export const accessAsset = [AssetSecurityRight.CanAccess];
export const manageAsset = [AssetSecurityRight.Manage];

export const accessEquipment = [EquipmentSecurityRight.CanAccess];
export const manageEquipment = [EquipmentSecurityRight.CanManage];

export const jobManageOtherUserViewsRights = [JobSecurityRight.MangeOtherUserViews];
export const jobReverseWorkOrderStatusRights = [JobSecurityRight.ReverseWorkOrderStatus];

export const schedulerManageRunsheetRights = [SchedulerSecurityRight.ManageRunSheets];
export const schedulerManageAppoitmentRights = [SchedulerSecurityRight.ManageAppointments];
export const schedulerManageOtherUserResourceGroupsRights = [SchedulerSecurityRight.ManageOtherUserResourceGroups];
export const schedulerManageFieldAllocations = [SchedulerSecurityRight.ManageFieldAllocations];

export const loginToFieldRights = [AppSecurityRight.LoginField];
export const loginToWebRights = [AppSecurityRight.LoginWeb];
export const loginToClientRights = [AppSecurityRight.LoginClient];
export const loginToPublicApiRights = [AppSecurityRight.LoginPublicApi];

// Adding a customer or supplier from anywhere follows that kind's Create (WBS-12233, WBS-12235).
export const crmCreateCustomers = [CrmSecurityRight.CustomersCreate];
export const crmCreateSuppliers = [CrmSecurityRight.SuppliersCreate];
export const crmManageServiceProviders = [CrmSecurityRight.ManageServiceProviders];
export const crmManageCustomers = [CrmSecurityRight.ManageCustomers];
export const crmManageSites = [CrmSecurityRight.ManageSites];
export const crmManageSuppliers = [CrmSecurityRight.ManageSuppliers];
export const crmManageEmployees = [CrmSecurityRight.ManageEmployees];
export const crmManageCompanies = [CrmSecurityRight.ManageCompanies];
export const crmManageSubcontractors = [CrmSecurityRight.ManageSubcontractors];
export const crmManageSecurityRights = [CrmSecurityRight.ManageSecurityRoles];
export const crmViewAuditLog = [CrmSecurityRight.ViewAuditLog];

export const accessVariation = [VariationSecurityRight.CanAccess];
export const manageVariation = [VariationSecurityRight.Manage];

export const accessRecurringJob = [RecurringJobSecurityRight.CanAccess];
export const manageRecurringJob = [RecurringJobSecurityRight.Manage];

export const manageTaskChecklist = [TaskSecurityRight.ManageTaskChecklists];

export const accessTask = [TaskSecurityRight.CanAccess];

export const accessTimesheet = [TimesheetSecurityRight.CanAccess];
export const manageMyTimesheets = [TimesheetSecurityRight.ManageMyTimesheets];
export const manageAllTimesheets = [TimesheetSecurityRight.ManageAllTimesheets];

export const accessFinancialRecap = [JobSecurityRight.ViewPricing];

export const clientManageActivity = [PortalClientSecurityRight.ManageActivity];
export const accessPayments = [FinanceSecurityRight.CanAccessPayments];

//Inbound Email Permissions
export const canAccessInboundEmail = [InboundEmailSecurityRight.CanAccess];


//Form security stuff
export const canModifySubmittedForm = [FormSecurityRight.ModifyAfterSubmission];
export const canCreateEditForms = [FormSecurityRight.CreateEditForms];
export const canDeleteForms = [FormSecurityRight.DeleteForms];

export const accessPurchaseOrder = [FinanceSecurityRight.CanAccessPurchaseOrder];
export const managePurchaseOrderRights = [FinanceSecurityRight.ManagePurchaseOrder];
export const processingPurchaseOrderRights = [FinanceSecurityRight.ProcessingPurchaseOrder];
export const approvePurchaseOrderRights = [FinanceSecurityRight.ApprovePurchaseOrder];

// contractor rights
export const portalCanModifySubmittedForm = [PortalContractorSecurityRight.ModifyFormAfterSubmission];
